{
  "name": "@nftearth/reservoir-kit-ui",
  "description": "ReservoirKit is the official frontend kit to get you started building dApps with the ReservoirProtocol.",
  "version": "0.10.5",
  "author": "Reservoir Protocol",
  "license": "MIT",
  "source": "src/index.ts",
  "exports": "./dist/index.module.js",
  "module": "dist/index.module.js",
  "types": "dist/index.d.ts",
  "type": "module",
  "files": [
    "dist"
  ],
  "keywords": [
    "nft",
    "reservoir",
    "reservoirkit",
    "protocol",
    "sdk"
  ],
  "sideEffects": false,
  "scripts": {
    "clean": "rm -rf dist",
    "version": "yarn version",
    "version:package": "sh ../../scripts/package-version.sh",
    "version:update": "yarn version ${0}; PACKAGE_VERSION=$(yarn version:package); git add -A; git commit -m \"🎉 Release ui package v$PACKAGE_VERSION\"; git push",
    "version:prerelease": "yarn version prerelease; RC_VERSION=$(yarn version:package); git add -A; git commit -m \"✨ Prerelease ui package v$RC_VERSION\"; git push;",
    "changelog": "node ../../scripts/generate-changelog.js package=ui"
  },
  "dependencies": {
    "@fortawesome/fontawesome-svg-core": "^6.1.1",
    "@fortawesome/free-solid-svg-icons": "^6.1.1",
    "@fortawesome/react-fontawesome": "^0.2.0",
    "@nftearth/reservoir-sdk": "workspace:*",
    "@radix-ui/colors": "^0.1.8",
    "@radix-ui/react-dialog": "1.0.1-rc.2",
    "@radix-ui/react-popover": "1.0.1-rc.2",
    "@radix-ui/react-scroll-area": "1.0.1-rc.2",
    "@radix-ui/react-select": "1.0.1-rc.2",
    "@radix-ui/react-switch": "1.0.0",
    "@radix-ui/react-toggle-group": "^1.0.0",
    "@react-hookz/web": "^19.2.0",
    "@stitches/react": "^1.2.8",
    "@wagmi/core": "^0.9.5",
    "dayjs": "^1.11.4",
    "flatpickr": "^4.6.13",
    "framer-motion": "^6.4.2",
    "react-flatpickr": "^3.10.13",
    "swr": "2.0.1"
  },
  "peerDependencies": {
    "ethers": "^5.6.1",
    "react": "^18.0",
    "react-dom": "^18.0",
    "wagmi": "^0.10.11"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/reservoirprotocol/reservoir-kit"
  }
}
